import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';




@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnChanges {
  @Input() urlString: string;
    constructor(private router: Router)
    {
  }

  changeLog: string[] = [];

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        let chng = changes[propName];
        let cur  = JSON.stringify(chng.currentValue);
        let prev = JSON.stringify(chng.previousValue);
        this.changeLog.push(`${propName}: currentValue = ${cur}, previousValue = ${prev}`);
      }
    }

    //console.log(this.urlString);
    if (typeof(this.urlString) !== 'undefined')
    {
      let segmentos = this.urlString['urlPay'].split('/');
      let url = ['dashboard'];

      segmentos.forEach(element => {
        url.push(element);
      });
    this.router.navigate(url);
   // this.router.navigate(['dashboard', this.urlString['urlPay']]);
  }
}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/chat/chat.component.ts